import { c as _c } from "react/compiler-runtime";
import { addMinutes, format, isBefore } from 'date-fns';
import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import type { CalendarEvent } from '@/app/(marketing-site)/bezplatna-konsultacja/_components/CalendarEvent';
type UseGenerateEventsSlotsForSelectedDayProps = {
  forDay: Date;
  setEventsForSelectedDay: (eventsSlots: Map<string, CalendarEvent[]>) => void;
  bookedEventIdsSet: Set<string>;
};
export function useGenerateEventsSlotsForSelectedDay(t0) {
  const $ = _c(5);
  const {
    forDay,
    setEventsForSelectedDay,
    bookedEventIdsSet
  } = t0;
  let t1;
  let t2;
  if ($[0] !== bookedEventIdsSet || $[1] !== forDay || $[2] !== setEventsForSelectedDay) {
    t1 = () => {
      const start = new Date(forDay.getFullYear(), forDay.getMonth(), forDay.getDate(), 8, 0);
      const end = new Date(forDay.getFullYear(), forDay.getMonth(), forDay.getDate(), 22, 0);
      const events = new Map();
      for (let slotStart = new Date(start); isBefore(slotStart, end); slotStart = addMinutes(slotStart, 30)) {
        const key = format(slotStart, "yyyy-MM-dd'T'HH:mm");
        const event = {
          id: uuidv4(),
          startTime: new Date(slotStart),
          endTime: addMinutes(slotStart, 30),
          summary: "Spotkanie z mentorem AlgoAcademy",
          location: "",
          typeId: "phone-call",
          isBooked: bookedEventIdsSet.has(key)
        };
        events.set(key, [event]);
      }
      setEventsForSelectedDay(events);
    };
    t2 = [forDay, bookedEventIdsSet, setEventsForSelectedDay];
    $[0] = bookedEventIdsSet;
    $[1] = forDay;
    $[2] = setEventsForSelectedDay;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
}